import { render, staticRenderFns } from "./my-credentials.vue?vue&type=template&id=4fb45219&scoped=true"
import script from "./my-credentials.vue?vue&type=script&lang=js"
export * from "./my-credentials.vue?vue&type=script&lang=js"
import style0 from "./my-credentials.scss?vue&type=style&index=0&id=4fb45219&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb45219",
  null
  
)

export default component.exports